import Layout from '../../components/Layout/Layout.component';
import Breadcrumbs from '../../components/Breadcrumbs.component';
import { Paths } from '../../utils/routerUrls';
import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import { Container, Grid } from '@material-ui/core';
import { ButtonOne } from '../../components/ButtonOne/ButtonOne.component';
import { useEffect, useState } from 'react';
import { IMovieListItem, IMovieListResponse } from '../../services/supportMovie/supportMovie.types';
import { deleteMovie, getMoviesList } from '../../services/supportMovie/supportMovie.service';
import { MovieDetails } from '../../components/SupportMovie/MovieDetails/MovieDetails.component';
import { AxiosResponse } from 'axios';
import { useLayoutContext } from '../../Context/Layout.context';
import usePermission, { UserPermission } from '../../hooks/usePermission';
import { MovieAdd } from '../../components/SupportMovie/MovieAdd/MovieAdd.component';
import { EditMovie } from '../../components/SupportMovie/EditMovie/EditMovie.component';
import { Prompt } from '../../components/Prompt/Prompt.component';
import { useStyles } from './SupportMovie.styles';
import { useStyles as mainStyles } from '../styles';
import Typography from '@material-ui/core/Typography';

export const SupportMovies: React.FC = () => {
  const { t } = useTranslation();
  useDocumentTitle('Materiały wideo');
  const [movies, setMovies] = useState<IMovieListItem[]>([]);
  const isAdminPermission = usePermission(UserPermission.AdminSupportManage);
  const [isAddMovieOpen, setIsAddMovieOpen] = useState<boolean>(false);
  const [movieDataToEdit, setMovieDataToEdit] = useState<IMovieListItem | undefined>(undefined);
  const [deletingMoviePromptData, setDeletingMoviePromptData] = useState<
    { movieId: string; title: string } | undefined
  >(undefined);
  const classes = useStyles();
  const mainClasses = mainStyles();

  const { openAlert } = useLayoutContext();

  const refreshData = () =>
    getMoviesList()
      .then((responce: AxiosResponse<IMovieListResponse>) => {
        setMovies(responce.data.list);
      })
      .catch(() => {
        console.error('error', `Nie udało się załadować pliku`);
      });

  useEffect(() => {
    refreshData();
  }, []);

  const handleDeleteMovie = (movieId: string) => {
    deleteMovie(movieId)
      .then(
        (response: AxiosResponse<boolean>) => {
          if (response.data) {
            openAlert('success', 'Usuwanie pliku zostało pomyślnie zakończone');
            refreshData();
          } else {
            openAlert('error', `Usuwanie pliku nie powiodło się`);
          }
        },
        () => openAlert('delete_error'),
      )
      .finally(() => {
        setDeletingMoviePromptData(undefined);
      });
  };

  return (
    <Layout viewType={isAdminPermission ? 'admin' : 'fullwidthForExaminer'}>
      <div>
        <Breadcrumbs
          listRoute={Paths.supportMovies}
          currentList="Materiały wideo"
          mainElementRoute={Paths.support}
          mainElement={`Centrum pomocy ${t('global:shortNames.beneficiary')} ${t('global:shortNames.system')}`}
        />
      </div>
      <Container className={classes.movieContainer} maxWidth="xl">
        {isAdminPermission && (
          <ButtonOne
            className={classes.movieAddButton}
            variant="contained"
            aria-label="Dodaj movie"
            onClick={() => setIsAddMovieOpen(true)}
          >
            {/* {t('support:header.pdfAdd')} */}
            <span className={classes.movieAddButtonSpan}>+</span> Dodaj film
          </ButtonOne>
        )}

        <Typography variant="h1" className={mainClasses.gridHeader} style={{ margin: '10px 5px' }}>
          Materiały wideo
        </Typography>

        {isAddMovieOpen && <MovieAdd onClose={() => setIsAddMovieOpen(false)} onChange={refreshData} />}

        {movieDataToEdit && (
          <EditMovie onClose={() => setMovieDataToEdit(undefined)} onChange={refreshData} movieProp={movieDataToEdit} />
        )}

        {deletingMoviePromptData && (
          <Prompt
            type="confirmation"
            open={true}
            size="xs"
            onConfirm={() => handleDeleteMovie(deletingMoviePromptData.movieId)}
            onCancel={() => setDeletingMoviePromptData(undefined)}
            mainActionButtonText="TAK"
            mainText="Czy na pewno chcesz usunąć film:"
            subTexts={[{ text: deletingMoviePromptData.title }]}
          />
        )}

        <Grid container spacing={2} className={classes.gridConteiner}>
          {movies &&
            movies.map((movie) => (
              <MovieDetails
                key={movie.id}
                movieProps={movie}
                deleteFunc={() => setDeletingMoviePromptData({ movieId: movie.id, title: movie.title })}
                updateFunc={() => setMovieDataToEdit(movie)}
                isAdminPermission={isAdminPermission}
              />
            ))}
        </Grid>
      </Container>
    </Layout>
  );
};
